import React from 'react';

const s = {
  footer: {
    background: '#030610',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: '60px 0 0',
  },
  container: { maxWidth: 1100, margin: '0 auto', padding: '0 24px' },
  grid: { display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr', gap: 40, marginBottom: 48 },
  logo: {
    display: 'flex', alignItems: 'center', gap: 10,
    fontFamily: 'Sora, sans-serif', fontWeight: 700, fontSize: 20,
    color: '#f0f4ff', marginBottom: 14,
  },
  logoIcon: {
    width: 32, height: 32,
    background: 'linear-gradient(135deg, #6c63ff, #3b82f6)',
    borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14, fontWeight: 800, color: '#fff',
  },
  tagline: { fontSize: 13, color: '#8892b0', fontFamily: 'DM Sans, sans-serif', lineHeight: 1.7, maxWidth: 220, marginBottom: 20 },
  socialRow: { display: 'flex', gap: 10 },
  socialBtn: {
    width: 34, height: 34, borderRadius: 8,
    background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', fontSize: 14, transition: 'all 0.2s',
  },
  colTitle: { fontFamily: 'Sora, sans-serif', fontSize: 13, fontWeight: 700, color: '#f0f4ff', marginBottom: 16, letterSpacing: 0.3 },
  colLink: {
    display: 'block', fontSize: 13, color: '#8892b0',
    fontFamily: 'DM Sans, sans-serif', marginBottom: 10,
    cursor: 'pointer', transition: 'color 0.2s',
  },
  bottom: {
    borderTop: '1px solid rgba(255,255,255,0.05)',
    padding: '20px 0',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  },
  copy: { fontSize: 12, color: '#4a5568', fontFamily: 'DM Sans, sans-serif' },
  flag: { fontSize: 14 },
  status: { display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#22c55e', fontFamily: 'DM Sans, sans-serif' },
  statusDot: { width: 7, height: 7, borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 6px rgba(34,197,94,0.6)' },
};

const cols = [
  { title: 'Producto', links: ['Beneficios', 'Planes y Precios', 'Seguridad', 'Novedades'] },
  { title: 'Empresa', links: ['Quiénes somos', 'Blog', 'Trabaja con nosotros', 'Prensa'] },
  { title: 'Soporte', links: ['Documentación', 'Centro de ayuda', 'Estado del sistema', 'Contáctanos'] },
  { title: 'Legal', links: ['Términos de uso', 'Aviso de privacidad', 'Política de cookies', 'Licencias'] },
];

export default function Footer() {
  return (
    <footer style={s.footer}>
      <div style={s.container}>
        <div style={s.grid}>
          <div>
            <div style={s.logo}>
              {/* <div style={s.logoIcon}>AV</div> */}
              <span>Archi<span style={{ color: '#6c63ff' }}>Vex</span></span>
            </div>
            <p style={s.tagline}>
              La plataforma líder en gestión documental empresarial para México y Latinoamérica. Segura, escalable y fácil de usar.
            </p>
            <div style={s.socialRow}>
              {['𝕏', 'in', '▶', '✉'].map((icon, i) => (
                <div key={i} style={s.socialBtn}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(108,99,255,0.2)'; e.currentTarget.style.borderColor = 'rgba(108,99,255,0.4)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}
                >{icon}</div>
              ))}
            </div>
          </div>

          {cols.map(col => (
            <div key={col.title}>
              <div style={s.colTitle}>{col.title}</div>
              {col.links.map(link => (
                <span key={link} style={s.colLink}
                  onMouseEnter={e => e.target.style.color = '#f0f4ff'}
                  onMouseLeave={e => e.target.style.color = '#8892b0'}
                >{link}</span>
              ))}
            </div>
          ))}
        </div>

        <div style={s.bottom}>
          <div style={s.copy}>
            © 2026 ArchiVex. Todos los derechos reservados. Hecho en México <span style={s.flag}>🇲🇽</span>
          </div>
          <div style={s.status}>
            <div style={s.statusDot} />
            Todos los sistemas operando con normalidad
          </div>
        </div>
      </div>
    </footer>
  );
}
